import { ConfigurationType } from 'civil-status/constants/configuration-type';
import { SectionVM, DatiEventoCittadinanza, ParentVM } from 'civil-status/view-models/step-form';
import { ID_ALTRO_COMUNE } from 'shell/components/shared/municipality-list';
import { CODE_APOLIDE } from 'shell/components/shared/nationality-list';

export const transformerDatiEventoCittadinanza = (
  idEvento?: number,
  dataSection?: SectionVM,
  dataPubblicoImpiego?: SectionVM,
  subjectCittadinanza?: ParentVM,
  dataTranscriptionCitizenship?: SectionVM,
  subjectOfficianteCitt?: ParentVM
): DatiEventoCittadinanza | undefined => {
  if (
    !(
      dataSection ||
      subjectCittadinanza?.generality ||
      dataPubblicoImpiego ||
      dataTranscriptionCitizenship ||
      subjectOfficianteCitt
    )
  ) {
    return undefined;
  }

  const isOtherMunicipality =
    dataSection?.italian?.municipality?.code?.toString() === ID_ALTRO_COMUNE;

  return {
    key: idEvento
      ? {
          idEvento,
        }
      : undefined,
    dataDecretoConferimento: dataSection?.dateConferralDecree
      ? dataSection.dateConferralDecree.toFormat('yyyy-MM-dd')
      : undefined,
    dataNotificaDecreto: dataSection?.dateNotificationDecree
      ? dataSection.dateNotificationDecree.toFormat('yyyy-MM-dd')
      : undefined,
    estremiDecretoConf: dataSection?.extremesDecree || undefined,
    indirizzoAutorita: dataSection?.authorityPostAddress || undefined,
    riassuntoDichiarazione:
      dataSection?.summaryStatement || dataTranscriptionCitizenship?.summaryStatement || undefined,
    infoResidenzaBiennale: dataSection?.templateTranscriptionText || undefined,
    residenza: dataSection?.typeResidence || undefined,
    provinciaResidenza: dataSection?.italian?.municipality?.provinceCode
      ? Number.parseInt(dataSection?.italian?.municipality?.provinceCode, 10)
      : undefined,
    siglaProvResidenza: dataSection?.italian?.municipality?.province || undefined,
    comuneResidenza: dataSection?.italian?.municipality?.id
      ? Number.parseInt(dataSection?.italian?.municipality?.id, 10)
      : undefined,
    nomeComuneResidenza: isOtherMunicipality
      ? dataSection?.italian?.otherMunicipality || undefined
      : dataSection?.italian?.municipality?.description,
    impiego: dataSection?.typeService || undefined,
    nazioneImpiego: dataSection?.nationEmployment?.code
      ? Number.parseInt(dataSection?.nationEmployment?.code, 10)
      : undefined,
    nomeNazioneImpiego: dataSection?.nationEmployment?.value || undefined,
    dataRegistrazioneDecreto: dataSection?.dateRegistrationCourt
      ? dataSection?.dateRegistrationCourt.toFormat('yyyy-MM-dd')
      : undefined,
    eventoCittadinanza:
      dataSection?.configuration === ConfigurationType.RICGENIT ||
      dataSection?.configuration === ConfigurationType.GIURCIT ||
      dataSection?.configuration === ConfigurationType.GIURCIT2 ||
      dataTranscriptionCitizenship?.configuration === ConfigurationType.TRATXBASR ||
      dataTranscriptionCitizenship?.configuration === ConfigurationType.TRATXBASQ
        ? '1'
        : dataTranscriptionCitizenship?.configuration === ConfigurationType.TRATXBASF
        ? '2'
        : dataSection?.parentCitizenship || undefined,
    protocollo: dataSection?.requestProtocol || undefined,
    dataVerbale: dataSection?.dateReport
      ? dataSection?.dateReport.toFormat('yyyy-MM-dd')
      : undefined,
    dataInizioResidenza: subjectCittadinanza?.generality?.dateStartResidence
      ? subjectCittadinanza?.generality?.dateStartResidence.toFormat('yyyy-MM-dd')
      : undefined,
    flagIntestatarioApolide:
      subjectCittadinanza &&
      (subjectCittadinanza.configuration === ConfigurationType.INTCIT ||
        subjectCittadinanza.configuration === ConfigurationType.INTCIT2)
        ? subjectCittadinanza?.generality?.nationality?.idAnpr?.toString() === CODE_APOLIDE
          ? '1'
          : '0'
        : undefined,
    tipoPerditaPerMatrimonio: subjectCittadinanza?.generality?.reasonLossCitizenship?.id
      ? Number.parseInt(subjectCittadinanza?.generality?.reasonLossCitizenship.id?.toString(), 10)
      : undefined,
    testoMotivoPerditaCittadinanza:
      subjectCittadinanza?.generality?.reasonLossCitizenship?.value ||
      dataSection?.reasonLossCitizenship ||
      undefined,
    dataGiuramento: dataSection?.dateOath ? dataSection.dateOath.toFormat('yyyy-MM-dd') : undefined,
    estremiGiuramento: dataSection?.extremesOath || undefined,
    tempoAssunzione: dataPubblicoImpiego?.hiringTiming || undefined,
    tipoOfficiante:
      subjectCittadinanza?.generality?.ufcDelegate ||
      subjectOfficianteCitt?.generality?.ufcDelegate ||
      undefined,
  };
};
